// Imports MUI Components
import { Box, Typography, Button, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

// Import CSS
import Text from "../../atoms/text/Text";
import Icon from "../../atoms/icon/Icon";
import ButtonComp from "../../atoms/button/Button";

const Empty = ({ 
  header,
  message,
  icon,
  buttonOn
}) => {
  return (
                              <Stack
                                direction="column"
                                spacing={3}
                                sx={{
                                  pt: "70px",
                                  px: {
                                    xs : "0",
                                    sm : "100px",
                                    md : "100px",
                                    lg : "100px",
                                    xl : "100px",
                                  },
                                  justifyContent: "center",
                                  textAlign: "center",
                                  justifyItems: "center",
                                  alignContent: "center",
                                  alignItems: "center",
                                }}>

                                  <Box
                                    sx={{
                                      backgroundColor: "rgba(46, 45, 45, 0.05)",
                                      borderRadius: "150px",
              boxShadow: '0 0.5px 5px rgba(0,0,0,0.5)',
                                      width: "80px",
                                      height: "80px",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  justifyItems: "center",
                                  alignContent: "center",
                                  alignItems: "center",
                                    }}>
                                      
                                  <Icon
                                    src={icon}
                                    size="large"/>
                                    </Box>

                                  <Stack
                                    direction="column"
                                    spacing={1}>

                                    <Text
                                      text={header}
                                      variant="headerh2"/>

                                    <Text
                                      text={message}
                                      variant="body1"/>

                                  </Stack>

                            {buttonOn && (

                      <ButtonComp
                        variant="contained"
                        noElevate={true}
                        noRipple={true}
                        label="Schedule Appointment"
                        color="light"
                        paddings="default"
                        background="default"
                        font="default"
                        weight="default"
                        transform="default"
                        selected={true}
                        keys={false}
                        hoverTextColor="default"
                        hoverBackground="default"
                        hoverBorder="none"
                        type="default"
                        justify="default"
                        destination="/patient-appointment-booking"
                        open={true}/>
                            )}

                                  </Stack>
  );
};

export default Empty;
